import React from 'react';
import { Button } from 'bloomer';
import { colors } from '../../styles/colors';
import styled from 'styled-components';

type SubmitButtonProps = {
  disabled?: boolean;
  loader?: boolean;
};

export class SubmitButton extends React.PureComponent<SubmitButtonProps> {
  render() {
    return (
      <ButtonWithShadow type="submit" className={this.props.loader ? ' button is-loading' : 'button '} disabled={this.props.disabled}>
        {this.props.children}
      </ButtonWithShadow>
    );
  }
}

const ButtonWithShadow = styled(Button)`
  color: white;
  height: 3rem;
  width: 100%;
  margin-top:1em;
  background-color: ${colors.circleBlue};
  box-shadow: 0 0 15px ${colors.circleBlue}88;
  border-radius: 0.5em;
  border: none;
  transition: box-shadow 0.25s;

  &:hover,
  &:active,
  &:focus {
    color: white;
    box-shadow: 0 0 15px ${colors.circleBlue};
  }

  :disabled {
    background-color: ${colors.circleBlue};
    opacity: 0.8;
  }

  :disabled:hover,
  :disabled:active,
  :disabled:focus {
    box-shadow: none;
  }
`;
